import React ,{useState} from 'react'

const Sidebar = ({toggleSidebar , open}) => {
  const[selectedIdx, setSelectedIdx] = useState(null)
  const [categoryOpen, setCategoryOpen] = useState(null)
  
    
    const iconss = [
      {
      name:"home",
      category:[
         
      ]
    },
      {
      name:"sports",
      category:[
        {
          name:"exchange",
          img:"https://9wicket.pro/images/casinoIcon/EXCHANGE.svg"
        },
        {
          name:"i sports",
          img:"https://9wicket.pro/images/casinoIcon/I-SPORTS.svg"
        }, 
        {
          name:"h book",
          img:"https://9wicket.pro/images/casinoIcon/HORSEBOOK.svg"
        }, 
        {
          name:"virtual",
          img:"https://9wicket.pro/images/casinoIcon/VIRTUAL.svg"
        }, 
      ]
    },
      {
      name:"casino",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
      {
      name:"slot",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
      {
      name:"table",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
      {
      name:"fishing",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
      {
      name:"arcade",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
      {
      name:"lottery",
      category:[
        {
          name:"evolution",
          img:"https://9wicket.pro/images/casinoIcon/Casino/EVOLUTION.webp"
        },
        {
          name:"sexy",
          img:"https://9wicket.pro/images/casinoIcon/Casino/SEXYBCRT.png"
        }, 
        {
          name:"pp",
          img:"https://9wicket.pro/images/casinoIcon/Casino/provider-awcmpp.png"
        }, 
        {
          name:"hotroad",
          img:"https://9wicket.pro/images/casinoIcon/Casino/HOTROAD.png"
        }, 
      ]
    },
  ]

  const icons2 = [
    { name: "Promotions ", src: "https://9wicket.pro/images/extra-icon/icon-promotion.svg" },
    { name: "VIP", src: "	https://9wicket.pro/images/extra-icon/icon-vip.svg" }, 
  ];

  const downIcons2 = [
    { name: "affiliate ", src: "https://9wicket.pro/images/extra-icon/icon-affiliate.svg" },
    { name: "24/7 liveChat", src: "https://9wicket.pro/images/extra-icon/icon-vip.svg", desc:"provides 24/7 quality service" }, 
    { name: "forum", src: "https://9wicket.pro/images/extra-icon/icon-member-phone.svg", }, 
    { name: "brand ambassador", src: "https://9wicket.pro/images/extra-icon/icon-affiliate.svg", desc:"play with celebrity" }, 
  ];


  // import krdo sidebar ko navbar me 
  // import kar dia 
  return (
    <>
    {/* Overlay */}
    {open && (
      <div
        className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-[9999]"
        onClick={()=>{
          setCategoryOpen(false)
          toggleSidebar()
        }} // Closes the sidebar when clicking on the overlay
      ></div>
    )}

    {/* Sidebar */}
    <div
      className={`fixed top-0 left-0 h-full text-white transition-transform duration-300 ${
        open ? "translate-x-0" : "-translate-x-full"
      } w-72 shadow-lg z-[9999] overflow-y-scroll bg-black`}
    >
      <div className=" bg-bg-2">
      {iconss.map((menu, idx)=>{
        
        return(
          <div>
          <SideBarContent idx={idx} key={menu.name} category={menu.category} categoryOpen={categoryOpen} setCategoryOpen={setCategoryOpen} setSelectedIdx={setSelectedIdx} selectedIdx={selectedIdx} name={menu.name} />
          </div>
        )

      })}
      
      </div>
      <div className="mt-2  bg-bg-2">
        {icons2.map((menu) => (
          <SideBarContent key={menu.name} name={menu.name} src={menu.src} />
        ))}
      </div>
      <div className="mt-2 px-2  bg-bg-2">
        {downIcons2.map((menu) => (
          <DownContent
            key={menu.name}
            name={menu.name}
            src={menu.src}
            desc={menu.desc}
          />
        ))}
      </div>
    </div>
  </>
  );
}

export default Sidebar


const SideBarContent = ({category,name, src, idx, categoryOpen, setCategoryOpen, setSelectedIdx, selectedIdx }) =>{
  // console.log(name, "alpha->>>>>")
  return <div>
   <div
  onClick={()=>{
    setCategoryOpen(true)
    setSelectedIdx(idx)
  }}
  className=' font-custom flex gap-2 border-b border-brd pb-2 items-center px-1 mt-[2px]'>
    <div>
      <img src={src?src:`/new_img/${name}.png`} width={40} className=' rounded-full' alt="" />
    </div>
    <div>
      <h2 className=' font-bold capitalize'>{name}</h2>
    </div>
  </div>
  { categoryOpen && category && <Categories idx={idx} selectedIdx={selectedIdx} category={category} />}
  </div>
}


const DownContent = ({  name, src, desc})=>{
  return <div className=' font-custom border-2 flex gap-2 border-brd1 bg-[#333]  py-2 items-center px-1 mt-2 rounded-md'>
  <div>
  <img src={src} width={40} className=' rounded-full' alt="" />
  </div>
  <div>
  <h2 className=' font-bold capitalize'>{name}</h2>
  <p className=' text-[10px] font-bold capitalize'>{desc}</p>
  </div>
  </div>
  }

const Categories = ({ idx, selectedIdx, category})=>{
    console.log("categories: ", category, idx, selectedIdx);
    
    return <div className=' bg-[#252525] absolute top-0 h-full z-[9999] left-48'>
      {category.map((items)=> <div className={` ${idx===selectedIdx?"":"hidden"}  text-white w-full flex flex-col items-center justify-center bg-[#252525] py-3`}>
    <div>
      <img src={items.img} alt="" width={40} className="" />
    </div>
    <div> 
      <h3 className=" uppercase">{items.name}</h3>
    </div>
  </div>)}
    
    </div>
  }